import React, { useRef, useState } from 'react';
import { allProfilesCategories } from "../../data/CategoriesData"
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { ReCaptchaHidden } from '../../utilities/ReCaptchaForForms';
import { apiFetch } from "../../hooks/apiFetch"
import { emailValidation, mobileValidation } from "../../utilities/validations/inputsValidations"
import { useTranslation } from 'react-i18next';

export const ServicesProviders = () => {
    const form = useRef();
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const { register, handleSubmit, formState: { errors } } = useForm();
    const { t, i18n } = useTranslation();
    async function onSubmit(data) {
        setLoading(true);
        console.log("Form data: ", data); // Debug: Check form data
        // if (data.type && Array.isArray(data.type)) {
        //     data.type = data.type.join(', ');
        // }

        try {
            const response = await apiFetch(`${process.env.REACT_APP_MASAR_API_URL}/mailer/services-providers`, {
                method: "POST",
                body: JSON.stringify(data)
            });
            if (response.isSuccess) {
                setSuccess(true)
                setTimeout(() => {
                    navigate('/');
                }, 5000);
            } else {
                setErrorMessage(t("errorTryAgain"), response.message);
            }
        } catch (error) {
            console.error("Error during form submission: ", error); // Debug: Check error
            setErrorMessage(t("errorGetSupport"));
        } finally {
            setLoading(false);
            // navigate('/');
        }
    }

    return (
        <div>
            <div className='bg-light-gray my-4 py-3'>
                <h4 className='container c-darkOrange'>{t("Service Providers")}</h4>
                {i18n.language === 'ar' ?
                    <p className='container'>سجل معنا كمقدم للخدمات.. فضلا قم بتعبئة النموذج وسنتواصل معك</p> :
                    <p className='container'>Register with us as a service provider Now. Please fill out the form and we will contact you.</p>}
            </div>
            <div className='bg-dark-beige text-start'>
                <form id='service-provider-form' className='d-flex flex-column mx-auto my-4 gap-2 p-4 w-75 w-lg-50'
                    ref={form} onSubmit={handleSubmit(onSubmit)}
                    method="POST">
                    <div className="input-group input-group-sm">
                        <span className="input-group-text">{t("Name")}</span>
                        <input className={`form-control ${errors.name && "border border-danger"}`}
                            type="text"
                            {...register("name", { required: true, minLength: 10 })} />
                        {errors.name && <p className='errors-msg'>{t("errorName")}</p>}
                    </div>
                    <div className="input-group input-group-sm">
                        <span className="input-group-text">{t("Email")}</span>
                        <input className={`form-control ${errors.email && "border border-danger"}`}
                            type="email"
                            {...register("email", { required: true, pattern: emailValidation })} />
                        {errors.email && <p className='errors-msg'>{t("errorEmail")}</p>}
                    </div>
                    <div className="input-group input-group-sm">
                        <span className="input-group-text" >{t("Phone")}</span>
                        <input className='form-control text-start' type="tel" placeholder="05xxxxxxxx"
                            {...register("phone", { required: true, minLength: 10, pattern: mobileValidation })} />
                        {errors.phone && <p className='errors-msg'>{t("errorPhone")}</p>}
                    </div>
                    <div className="input-group input-group-sm">
                        <span className="input-group-text" >{t("Categories")}</span>
                        <select
                            className={`form-control form-control-sm`}
                            multiple
                            {...register("type", { required: true })}
                        >
                            <option defaultValue=""></option>
                            {allProfilesCategories.map((category, index) =>
                                <option key={index} value={category.ar}>
                                    {i18n.language === "ar" ? category.ar : category.en}</option>
                            )}
                        </select>
                        {errors.type && <p className='errors-msg'>{t("errorSelectCat")}</p>}
                    </div>
                    <div className="input-group input-group-sm">
                        <span className="input-group-text" >{t("Details")}</span>
                        <textarea
                            className={`form-control form-control-sm`}
                            type="text"
                            rows={4}
                            {...register("description")}
                        />
                        {errors.description && <p className='errors-msg'>{t("errorSelectCat")}</p>}
                    </div>
                    <div className="align-self-end">
                        <ReCaptchaHidden />
                    </div>
                    <button className="btn btn-light-beige text-white align-self-end w-auto"
                        type='submit'>
                        {loading &&
                            <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"></span>
                        }
                        {t("Send")}
                    </button>
                    {errorMessage &&
                        <div className="alert alert-danger alert-dismissible fade show" role="alert">
                            {errorMessage}
                            <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                        </div>}
                    {success &&
                        (i18n.language === 'ar' ?
                            <div className="alert alert-success alert-dismissible fade show" role="alert">
                                تم ارسال رسالتكم بنجاح .. شكرا لك
                                <br />
                                سنتواصل معك قريبا
                                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button> :
                            </div> :
                            <div className="alert alert-success alert-dismissible fade show" role="alert">
                                Your message has been sent successfully. Thank you.
                                <br />
                                We will contact you soon.
                                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                            </div>)}
                </form>
            </div>
        </div>
    );
};